import React, { useState } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet-async';
import './Contact.css';

function Contact() {
  const [form, setForm] = useState({ nom: '', email: '', telephone: '', message: '' });
  const [status, setStatus] = useState(null); // 'success' | 'error' | 'loading'

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('loading');
    try {
      await axios.post('/api/contact/', form);
      setStatus('success');
      setForm({ nom: '', email: '', telephone: '', message: '' });
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="contact-page">
      <Helmet>
        <title>Contact — Eagle Car's | Dépannage 24h/24 Haute-Savoie, Suisse, Ain</title>
        <meta name="description" content="Contactez Eagle Car's pour un dépannage urgence, devis ou rendez-vous. Disponible 24h/24 7j/7. Tél : 06 76 79 67 71. Intervention en Haute-Savoie, Ain, Genève, Lausanne, Berne." />
        <link rel="canonical" href="https://eaglecars.fr/contact" />
        <meta property="og:title" content="Contact Eagle Car's — Dépannage 24h/24" />
        <meta property="og:description" content="Disponible 24h/24 7j/7. Appelez le 06 76 79 67 71 pour un dépannage ou devis." />
        <meta property="og:url" content="https://eaglecars.fr/contact" />
        <meta property="og:image" content="https://eaglecars.fr/og-image.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>

      <div className="page-header container">
        <h1 className="section-title">Nous <span>Contacter</span></h1>
        <div className="gold-line centered" />
        <p className="section-subtitle">
          Une question, un devis, un dépannage urgent ? On est là.
        </p>
      </div>

      <div className="contact-body container">

        {/* Infos + Map */}
        <div className="contact-info">
          <div className="contact-info-block">
            <h3>Téléphone</h3>
            <a href="tel:+33676796771" className="contact-link contact-link-primary">
              06 76 79 67 71
            </a>
            <p className="contact-note">Dépannage disponible 24h/24 · 7j/7</p>
          </div>

          <div className="contact-info-block">
            <h3>Email</h3>
            <a href="mailto:garage.eagle.cars@gmail.com" className="contact-link">
              garage.eagle.cars@gmail.com
            </a>
          </div>

          <div className="contact-info-block">
            <h3>Adresse</h3>
            <p className="contact-address">
              40 Rte de la Libération<br />
              74100 Étrembières<br />
              France
            </p>
          </div>

          <div className="contact-map">
            <iframe
              title="Localisation Eagle Car's"
              src="https://maps.google.com/maps?q=40+Route+de+la+Libération+74100+Étrembières&output=embed"
              allowFullScreen
              loading="lazy"
            />
          </div>
        </div>

        {/* Formulaire */}
        <div className="contact-form-wrap">
          <h2 className="contact-form-title">Envoyer un message</h2>

          {status === 'success' && (
            <div className="contact-alert contact-alert-success">
              Message envoyé ! Nous vous répondrons rapidement.
            </div>
          )}
          {status === 'error' && (
            <div className="contact-alert contact-alert-error">
              Erreur lors de l'envoi. Appelez-nous directement au 06 76 79 67 71.
            </div>
          )}

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="nom">Nom *</label>
                <input
                  id="nom"
                  name="nom"
                  type="text"
                  value={form.nom}
                  onChange={handleChange}
                  required
                  placeholder="Votre nom"
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                  placeholder="votre@email.com"
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="telephone">Téléphone</label>
              <input
                id="telephone"
                name="telephone"
                type="tel"
                value={form.telephone}
                onChange={handleChange}
                placeholder="06 00 00 00 00"
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message *</label>
              <textarea
                id="message"
                name="message"
                value={form.message}
                onChange={handleChange}
                required
                rows={6}
                placeholder="Décrivez votre demande..."
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary contact-submit"
              disabled={status === 'loading'}
            >
              {status === 'loading' ? 'Envoi en cours...' : 'Envoyer le message'}
            </button>
          </form>
        </div>

      </div>
    </div>
  );
}

export default Contact;
